import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Checkbox } from 'components/Checkbox/Checkbox';
import { RunTournamentContainer } from '../styles';

export default React.memo(({ updateContestDetails }) => {
  let { contest } = useSelector((state) => state.CMSEditContestReducer);

  const [autoRun, setAutoRun] = useState(contest?.autoRun ?? false);
  // const [tournamentRunTime, setTournamentRunTime] = useState(contest?.tournamentRunTime ?? '');

  return (
    <RunTournamentContainer>
      <Checkbox
        checked={autoRun}
        onChange={() => {
          let newValue = !autoRun;
          setAutoRun(newValue);
          updateContestDetails({ autoRun: newValue });
        }}
        label="Run Automatically Every Night"
      />
      {/* {autoRun && (
        <RunTournamentTimeContainer>
          <Label>Set time: </Label>
          <Input
            type="time"
            step="1"
            value={tournamentRunTime}
            onChange={(e) => {
              console.log('e.target.value: ', e.target.value);
              setTournamentRunTime(e.target.value);
              updateContestDetails({ tournamentRunTime: e.target.value });
            }}
          />
        </RunTournamentTimeContainer>
      )} */}
    </RunTournamentContainer>
  );
});
